<template>
  <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside p-lg-5">
    <div class="m-stack m-stack--hor m-stack--desktop">
      <div class="m-stack__item m-stack__item--fluid">
        <div class="m-content">
          <div class="m-portlet m-portlet--last m-portlet--tab">
            <form class="m-form m-form--state m-form--fit m-form--label-align-center">
              <div class="m-portlet__body">
                <div class="m-login__logo">
                  <img src="/media/img/logo_superaccess.png">
                </div>
                <div class="form-group m-form__group has-danger centered">
                  <label class="m-login__msg">{{!sync ? 'Ingrese el código de activación' : 'Sincronice la información necesaria para continuar'}}</label>
                </div>
                <div v-show="!sync" class="form-group m-form__group row centered">
                  <div class="col-lg-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="la la-key"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control m-input" v-model="code" :placeholder="'enter_code' | capitalize">
                    </div>
                  </div>
                </div>
                <div v-show="!sync" class="form-group m-form__group row centered">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">
                    <button class="btn btn-primary btn-activate" @click.prevent="activate">
                      {{ 'activate' | capitalize }}
                    </button>
                  </div>
                </div>
                <div v-show="sync" class="form-group m-form__group row centered">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">
                    <button class="btn btn-primary btn-activate" @click.prevent="syncData">
                      {{ 'sync' | capitalize }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
        <div class="m-dropdown m-dropdown--up m-dropdown--inline m-dropdown--smallest m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" data-dropdown-toggle="click">
          <a href="#" class="m-portlet__nav-link m-dropdown__toggle btn btn-secondary m-btn m-btn--icon m-btn--pill">
            <span class="m-nav__link-text">
              <img :src="'/media/img/flags/'+$i18n.locale+'.png'" class="carousel-control-next-icon icon-flag-selector">
              {{ $i18n.locale | capitalize }}
            </span>
          </a>
          <div class="m-dropdown__wrapper language-dropdown">
            <div class="m-dropdown__inner">
              <div class="m-dropdown__body">
                <div class="m-dropdown__content">
                  <div class="m-scrollable" data-scrollable="true" data-max-height="110">
                    <ul class="m-nav text-nowrap">
                      <li v-for="(language,index) in  Object.keys($i18n.messages)" :key="index" class="m-nav__item">
                        <a @click="changeLanguage(language)" class="m-nav__link cursor-pointer">
                          <span class="m-nav__link-text ">
                            <img :src="'/media/img/flags/'+language+'.png'" class="carousel-control-next-icon icon-flag-selector">
                            {{ language | capitalize }}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      code: '',
      sync: false
    }
  },
  created () {
    if (this.$route.params.sync) this.sync = true
  },
  computed: {
    ...mapGetters({first_sync: 'getFirstSync'})
  },
  methods: {
    ...mapActions(['postActivate', 'changeLanguageStatus', 'firstSync']),
    activate () {
      this.$spinner.show()
      this.postActivate(this.code)
        .then((result) => {
          this.$spinner.remove()
          if (result.data.active) {
            this.$toast('activation_complete')
            this.sync = true
          } else {
            this.$toast(result.data.message, 3)
          }
        })
        .catch((error) => {
          this.$spinner.remove()
          this.$toast('activation_error', 4)
          console.log(error)
        })
    },
    syncData () {
      this.$spinner.show()
      this.firstSync().then((res) => {
        this.$spinner.remove()
        this.$toast('sync_complete')
        window.location.reload()
        // this.$router.push({name: 'login'})
      }).catch((err) => {
        this.$spinner.remove()
        this.$toast('sync_error', 4)
        console.log(err)
      })
    },
    changeLanguage (language) {
      this.changeLanguageStatus(true)
      this.$store.commit('setLocalLanguage', language)
      if (this.$i18n.locale !== language) {
        this.$i18n.locale = language
        this.$validator.localize(language)
      }
    }
  },
  watch: {
    first_sync (newVal) {
      this.sync = newVal
    }
  }
}
</script>

<style lang="sass" scoped>
.m-login__logo
  text-align: center
.m-login__logo > img
  width: 200px
.centered
  text-align: -webkit-center
</style>

<style scoped>
  .btn-activate {
    background-color: #001644 !important;
    border-color: #001644 !important;
  }
</style>


// WEBPACK FOOTER //
// Activation.vue